import type { Core } from '@strapi/strapi'

const destroy = ({ strapi }: { strapi: Core.Strapi }) => {
  // destroy phase
}

export default destroy
